import { render, staticRenderFns } from "./CalendarEventInvitees.vue?vue&type=template&id=f27b95a8&scoped=true&"
import script from "./CalendarEventInvitees.vue?vue&type=script&lang=ts&"
export * from "./CalendarEventInvitees.vue?vue&type=script&lang=ts&"
import style0 from "./CalendarEventInvitees.vue?vue&type=style&index=0&id=f27b95a8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f27b95a8",
  null
  
)

export default component.exports